import React from 'react'
import { useFragment, graphql } from 'react-relay'

import { YStack } from 'tamagui'
import { Image, Text } from '@newComponents'

import { HOST_NAME, IMAGEKIT_URL } from '@data/config/url'

import { EventScreenNewCoverPhoto_event$key } from './__generated__/EventScreenNewCoverPhoto_event.graphql'

const BACKGROUNDS = [
  'purple-yellow_zbyzdUESq.png',
  'pink-yellow_UvKUtm5f3.png',
  'blue-purple_F4x1_B8WX.png',
  'blue-teal_HwODg9qh1.png',
  'purple-blue_t3kh8e78Bl.png',
]

export const EventScreenNewCoverPhoto = ({
  event,
}: {
  event: EventScreenNewCoverPhoto_event$key
}) => {
  const data = useFragment(
    graphql`
      fragment EventScreenNewCoverPhoto_event on Event {
        name
        rowId
        prettyUrl
        visibility

        coverPhoto {
          rowId
          contentType
        }
      }
    `,
    event
  )

  if (data.coverPhoto) {
    return (
      <Image
        alt={`Cover Photo for ${data.name}`}
        src={`${IMAGEKIT_URL}/tr:w-368,dpr-3/${
          data.coverPhoto.rowId
        }.${data.coverPhoto.contentType.toLowerCase()}`}
        boxShadow='$boxShadowLight'
        width='100%'
        $gtXs={{
          borderRadius: '$6',
          maxWidth: 537,
        }}
        $gtSm={{
          maxWidth: '100%',
        }}
      />
    )
  }

  if (data.visibility === 'DRAFT') {
    // const shortRowId = data.rowId.substring(0, 8) || '0'

    // const backgroundToUse =
    //   BACKGROUNDS[parseInt(shortRowId, 16) % BACKGROUNDS.length]

    return (
      <YStack
        boxShadow='$boxShadowLight'
        aspectRatio={2}
        width='100%'
        gap='$4'
        alignItems='center'
        justifyContent='center'
        padding='$5'
        $gtXs={{
          borderRadius: '$6',
          maxWidth: 537,
        }}
        $gtSm={{
          maxWidth: '100%',
        }}
      >
        <Image
          alt={`Cover Photo for ${data.name}`}
          src={`https://ik.imagekit.io/guild/social-card-backgrounds/tr:w-368,dpr-3/purple-yellow_zbyzdUESq.png`}
          position='absolute'
          width='100%'
          height='100%'
          $gtXs={{
            borderRadius: '$6',
          }}
          $gtSm={{
            maxWidth: '100%',
          }}
        />

        <Text
          size='$4'
          textAlign='center'
          fontWeight='$6'
          zIndex='$2'
          color='$grey0'
        >
          We'll generate a cover photo once your event is public
        </Text>

        <Text
          size='$4'
          textAlign='center'
          fontWeight='$6'
          zIndex='$2'
          color='$grey0'
        >
          Or you can upload your own in the Settings page!
        </Text>
      </YStack>
    )
  }

  return (
    <Image
      alt={`Cover Photo for ${data.name}`}
      src={`${HOST_NAME}/social/event/${data.prettyUrl}/card.svg`}
      aspectRatio={2}
      boxShadow='$boxShadowLight'
      width='100%'
      $gtXs={{
        borderRadius: '$6',
        maxWidth: 537,
      }}
      $gtSm={{
        maxWidth: '100%',
      }}
    />
  )
}
